import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, patch, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetBannerCarouselApiParameter extends ApiParameter {
    isPreview: boolean;
    pageUrl: string;
    personaType?: string;
    isPageTypePdp?: boolean;
    adiNumber?: string;
    brand?: string;
    l3Category?: string;
    l2Category?: string;
    customerNumber?: string;
    customerDC?: any;
    startDate?: any;
    endDate?: any;
    checkRoles?: any;
    isRewardEnrolledUser?: boolean;
    isRewardInvitedUser?: boolean;
}

export interface GetBannerCarouselModel {
    uri: any
    bannerCarouselList: BannerCarouselList[] | [],
    marketingTileList: MarketingTileList[] | []
    pageUrl: any
    customerNumber: any
    customerDC: any
    personaType: any
    startDate: string
    endDate: string
    isPreview: boolean
    userRoles: any
    checkRoles: any
    isPageTypePdp: boolean
    adiNumber: any
    brand: any
    l3Category: any
    l2Category: any
    properties: Properties
}

export interface BannerCarouselList {
    richContent: string
    cssClass: string
    backgroundImage: string
    imageURL: string
    callToAction: string
    imageAlternativeText: string
    bodyAlignment: string
    imageAlignment: string
    centerBoxBackground: string
    bannerContentListID: string
    headerLineOne: string
    headerLineTwo: string
    copyTextOne: string
    copyTextTwo: string
    copyTextThree: string
    smallCopyTextOne: string
    smallCopyTextTwo: string
    bannerLinkUrl: string
    logoImageUrl: string
    bannerButtonText: string
    promoLayout: string
    status: any
    mobileBannerClass: string
    isNewTab: boolean
    isMiniBanner: boolean
    isPDPBanner: boolean
    isRewardEnrolledUser: boolean
    isRewardInvitedUser: boolean
}

export interface MarketingTileList {
    richContent: string
    cssClass: string
    backgroundImage: string
    imageURL: string
    callToAction: string
    imageAlternativeText: string
    bodyAlignment: string
    imageAlignment: string
    centerBoxBackground: string
    bannerContentListID: string
    headerLineOne: string
    headerLineTwo: string
    copyTextOne: string
    copyTextTwo: string
    copyTextThree: string
    smallCopyTextOne: string
    smallCopyTextTwo: string
    bannerLinkUrl: string
    logoImageUrl: string
    bannerButtonText: string
    promoLayout: string
    status: any
    mobileBannerClass: string
    isNewTab: any
    isMiniBanner: any
    isPDPBanner: any
}

export interface PreviewBannerCarouselParams {
    startDate: string
    isPreview: boolean
    pageUrl: string
    personaType: string,
    customerDC: string | undefined,
    customerNumber: string | undefined,
    checkRoles: string,
    endDate: string
}

export interface Properties { }

interface GetBaseModel extends BaseModel {
    bannerCarousel: GetBannerCarouselModel
}
const bannerPreviewUrl = "api/v2/previewbannercarousel";

const url = "/api/v2/getbannercarousel";
export async function getBannerCarousel(parameter: GetBannerCarouselApiParameter): Promise<ServiceResult<GetBaseModel>> {
    try {
        const bannerModel = await patch<GetBaseModel>(`${url}`, parameter as any);
        return {
            result: bannerModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getBannerPreviewCarousel(parameter: GetBannerCarouselApiParameter): Promise<ServiceResult<GetBaseModel>> {
    try {
        const bannerPreviewModel = await patch<GetBaseModel>(`${bannerPreviewUrl}`, parameter as any);
        return {
            result: bannerPreviewModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}






